var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container bill-check-page" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", [_vm._v("账单管理")]),
            _c("el-breadcrumb-item", [_vm._v("账单核对")])
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content bill-check-content" },
      [
        _c(
          "el-tabs",
          {
            attrs: { type: "card" },
            model: {
              value: _vm.activeTab,
              callback: function($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab"
            }
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "外部核对", name: "external" } },
              [_c("external-check")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "内部核对", name: "internal" } },
              [_c("internal-check")],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }